import { ENV } from '../../config/runtimeEnv';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_LABIQ_SERVER || '';

/**
 * Fetch intervention data with pagination and filters
 */
export const fetchInterventionsData = async (sampleID : string, sex?: string | null) => {
	const response = await http.get(`${API_BASE_URL}/getInterventions`, {
		params: {
			sample_id: sampleID,
			// Omitted, never blank: an unknown sex must exclude neither sex-specific wheel.
			...(sex ? { sex } : {})
		}
	});

	return response.data;
};
